<template>
    <div>
        <el-form class="evaluation-form-scoped" label-width="200px">
            <el-form-item label="评价意见" required>
                <el-radio-group v-model="form.userViewpoint" ref="userViewpoint">
                    <el-radio v-for="(item, index) in viewPointOptions" class="mr-20" :label="item.value" :key="index" v-if="item.value != '-1'">{{item.text}}</el-radio>
                </el-radio-group>
                <span style="color:#ff0000" v-show="form.userViewpoint === '3' || form.userViewpoint === '4'">无须填写薪资相关信息</span>
            </el-form-item>
            <el-form-item label="岗位建议方向"  required v-if="advise.length">
                <el-checkbox-group v-model="form.hireAdvice" ref="hireAdvice">
                    <el-checkbox v-for="(item, index) in advise" class="mr-20" :label="item" :key="index">{{item}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="建议薪资" :required="form.userViewpoint !== '3' && form.userViewpoint!== '4'" >
                  <el-input placeholder="请输入建议薪资" class="text-content" :maxlength="300" v-model="form.adviceSalary" ref="adviceSalary"></el-input>
            </el-form-item>
            <el-form-item label="当前薪资" :required="form.userViewpoint !== '3' && form.userViewpoint!== '4'" class="inner-row" >
                <el-row>
                    <el-col class="inner-td" :span="4">月基本薪资</el-col>
                    <el-col :span="4"><el-input ref="monthBaseSalary" class="text-content" :maxlength="20" placeholder="建议注明 税前/税后" type="textarea" v-model="form.monthBaseSalary"></el-input></el-col>
                    <el-col class="inner-td" :span="4">薪资一年发放月数</el-col>
                    <el-col :span="4"><el-input ref="monthCount" :maxlength="20" class="text-content" placeholder="填写实际月份数即可，如一年薪资发放13个月则填写：13" type="textarea" v-model="form.monthCount"></el-input></el-col>
                    <el-col class="inner-td" :span="4">其他福利补充</el-col>
                    <el-col :span="4"><el-input ref="otherWelfare" :maxlength="100" class="text-content" placeholder="如：包三餐、包住宿、每月项目奖金、其他奖金等" type="textarea" v-model="form.otherWelfare"></el-input></el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="期望薪资" :required="form.userViewpoint !== '3' && form.userViewpoint!== '4'"  >
                <el-input class="text-content" placeholder="请输入期望薪资" :maxlength="66" v-model="form.expectSalary" ref="expectSalary"></el-input>
            </el-form-item>
            <el-form-item label="面试记录" required>
                <el-input class="text-content" ref="interviewRecord" :maxlength="8000" placeholder="请输入面试问答详情" type="textarea" v-model="form.interviewRecord"></el-input>
            </el-form-item>
            <el-form-item label="综合评价" required >
                <el-input class="text-content" :maxlength="2000" ref="content" placeholder="请输入评价内容" type="textarea" v-model="form.content"></el-input>
            </el-form-item>
        </el-form>
        <society-form-tips v-if="false" :isSociety="true"  :scoreType="scoreType" ></society-form-tips>
        <div class="button-footer">
            <el-button type="primary" @click="submit">提交评估</el-button>
            <el-button @click="cancel">取消</el-button>
        </div>
    </div>
</template>

<script>
    import SelectMapMixin from 'mixins/selectMapMixin'
    import SocietyBaseForm from './society-form-base'
    import SocietyFormTips from './society-form-tips.vue'

    export default{
        mixins: [SelectMapMixin],
        extends: SocietyBaseForm,
        data () {
            return {
                showScoreTip: false,
                form: {
                    userViewpoint: '',
                    hireAdvice: [],
                    adviceSalary: '',
                    monthBaseSalary: '',
                    monthCount: '',
                    otherWelfare: '',
                    expectSalary: '',
                    interviewRecord: '',
                    content: ''
                }
            }
        },
        props: {
            recruitType: null,
            isEdit: false,
            scoreType: null,
            extInfo: null
        },
        components: {
            SocietyFormTips
        }
    }
</script>
<style lang="scss">
    @import "../evaluation-form";
</style>


// WEBPACK FOOTER //
// society-form-social-notqa.vue?73c443f4